var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15274_3531)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44435 8.35752L3.23322 7.83154C5.07337 6.60463 7.02791 5.55861 9.06951 4.70811C10.945 3.92681 13.0548 3.92681 14.9303 4.70811C16.9719 5.55861 18.9265 6.60463 20.7666 7.83154L21.5555 8.35752C22.7184 9.13286 22.7183 10.8417 21.5553 11.6169L20.7647 12.1439C18.9258 13.3697 16.9728 14.4149 14.9329 15.265C13.0558 16.0473 10.944 16.0473 9.06696 15.265C7.02704 14.4149 5.07403 13.3697 3.23515 12.1439L2.44454 11.6169C1.28159 10.8417 1.28149 9.13286 2.44435 8.35752ZM4.34272 9.49558L3.60548 9.98714L4.34446 10.4797C6.07615 11.6341 7.91531 12.6184 9.83632 13.4189C11.221 13.996 12.7788 13.996 14.1635 13.4189C16.0845 12.6184 17.9237 11.6341 19.6554 10.4797L20.3944 9.98714L19.6571 9.49558C17.9243 8.34022 16.0838 7.35521 14.1612 6.55432C12.778 5.97807 11.2219 5.97807 9.83861 6.55432C7.91608 7.35521 6.07555 8.34022 4.34272 9.49558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55458 14.1812C3.09503 13.8749 2.47417 13.9991 2.16784 14.4586C1.86152 14.9182 1.98572 15.539 2.44527 15.8454L2.6805 16.0022C4.57297 17.2637 6.5829 18.3394 8.68228 19.2143C10.8055 20.0991 13.1943 20.0991 15.3176 19.2143C17.4169 18.3394 19.4269 17.2637 21.3193 16.0022L21.5546 15.8454C22.0141 15.539 22.1383 14.9182 21.832 14.4586C21.5257 13.9991 20.9048 13.8749 20.4453 14.1812L20.21 14.338C18.4248 15.528 16.5287 16.5428 14.5482 17.3682C12.9173 18.0478 11.0825 18.0478 9.45164 17.3682C7.47117 16.5428 5.57509 15.528 3.78981 14.338L3.55458 14.1812Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15274_3531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.35137d62640aece551d2613cd008d8ee.svg";
export { ForwardRef as ReactComponent };